import { useQuery } from '@tanstack/react-query'

import { getOfferByIdOptions } from '@/entities/offer'

import { getReservationOptions } from '../options/getReservationOptions.ts'

export const useGetReservation = (
	offerId: string | undefined | null,
	options?: Parameters<typeof getOfferByIdOptions>[1]
) => {
	const query = useQuery(
		getReservationOptions(offerId as string, {
			enabled: (options?.enabled ?? true) && offerId != null
		})
	)

	return query
}
